import DualRangeSlider from '../form-inputs/inputDualRangeSlider';
import { FilterSubcategory, FrontendFilters } from '../../types/filters.type';
import MultiCheckbox from '../form-inputs/inputMulticheckbox';
import InputNumberToNumber from '../form-inputs/inputNumberToNumber';
import { InputSearchContainer } from '../../features/streetview';
import MultiCheckboxDropdown from '../form-inputs/inputMultiCheckboxDropdown';
import useScrollToElement from '../../hooks/useScrollToElement';
import { DelimiterRules } from '../../utils/pasteValueHandler';

interface SubFilterMenuProps {
  title: string;
  menuData: FilterSubcategory[];
  searchResult?: string | null;
}

export default function SubFilterMenu({ title, menuData, searchResult = null }: SubFilterMenuProps) {
  const { elementRef } = useScrollToElement<HTMLLIElement>(searchResult);
  const showFilter = (filter: FrontendFilters) => {
    switch (filter.type) {
      case 'dual_range_slider':
        return (
          <DualRangeSlider
            label={filter.displayName}
            labelId={filter.id}
            title={title}
            filterValues={filter.filterValues}
            description={filter.description}
            featureFlag={filter.featureFlag}
          />
        );
      case 'dropdown_checkbox_multiple':
        return (
          <MultiCheckboxDropdown
            multiSelectOptions={filter.filterValues}
            label={filter.displayName}
            labelId={filter.id}
            title={title}
            description={filter.description}
            featureFlag={filter.featureFlag}
            hasAllOption={filter.hasAllOption}
          />
        );
      case 'checkbox_multiple':
        return (
          <MultiCheckbox
            filterValues={filter.filterValues}
            label={filter.displayName}
            labelId={filter.id}
            title={title}
            description={filter.description}
            featureFlag={filter.featureFlag}
          />
        );
      case 'integer_to_integer':
        return (
          <InputNumberToNumber
            filterValues={filter.filterValues}
            label={filter.displayName}
            labelId={filter.id}
            title={title}
            description={filter.description}
            featureFlag={filter.featureFlag}
          />
        );
      case 'search':
      case 'search_space_delimited':
        return (
          <InputSearchContainer
            placement="auto"
            label={filter.displayName}
            labelId={filter.id}
            title={title}
            placeholder={filter.placeholder || 'Search...'}
            searchOptions={filter.filterValues}
            delimiterRules={
              filter.type === 'search_space_delimited'
                ? DelimiterRules.SpacesAreDelimiter
                : DelimiterRules.SpacesAreNotDelimiter
            }
          />
        );
      default:
        return <p className="text-piptext-body">Unsupported filter type</p>;
    }
  };
  return (
    <aside className="w-full">
      <div className="flex flex-col  border-pipgrey-border ">
        {menuData.map((subcategory) => (
          <div id={subcategory.id} key={subcategory.id}>
            <h3 className="text-secondary text-sm font-semibold mt-4 ps-4">
              {subcategory.displayName}
            </h3>
            {subcategory.description && (
              <p className="text-secondary text-xs ps-4 mt-2">
                {subcategory.description}
              </p>
            )}
            <ul className="space-y-2">
              {subcategory.filters.map((filter) => {
                const focused = filter.displayName === searchResult;
                return (
                  <li
                    ref={focused ? elementRef : null}
                    id={filter.id}
                    className={`border-b p-4 w-full ${focused ? 'focused-filter' : ''}`}
                    key={filter.id}
                  >
                    {showFilter(filter)}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </aside>
  );
}
